import React from "react";
import Header from "@components/MainHeader/MainHeader";
import Footer from "@components/MainFooter/MainFooter";
import { Outlet } from "react-router-dom";
import "@assets/bootstraps/bootstrap.css";
import "@assets/css/Home.scss";

const Home: React.FC<any> = ({ isLanding }) => {
  return (
    <div id="body">
      <Header />
      <Outlet />
      <Footer isLanding={isLanding} />
    </div>
  );
};

export default Home;
